import React from "react"
import img1 from "../../../assets/images/modals/modal1.png"
import img2 from "../../../assets/images/modals/modal2.png"
import img3 from "../../../assets/images/modals/modal3.png"
import img4 from "../../../assets/images/modals/modal4.png"
import img5 from "../../../assets/images/modals/modal5.png"

export const infoModal = [
  {
    txt:
      <>
        <span>LA ZONA V</span>
        <p>es un centro de gravedad y un territorio de poder. Cada una es única y diferente. <b>¡Siéntete
          orgullosa!</b></p>
      </>,
    img: img1
  },
  {
    txt:
      <>
        <span>¡Viva la vulva!</span>
        <p>Vivamos libres de tabúes y el mito de la vulva perfecta. No nos avergoncemos de nuestros genitales.</p>
      </>,
    img: img2
  },
  {
    txt:
      <>
        <p>Dejemos que las historias de</p>
        <span>nuestros úteros</span>
        <p>sean escuchadas. <b>¡Démosle voz a nuestro cuerpo!</b></p>
      </>,
    img: img3
  },
  {
    txt:
      <>
        <span>¡Sí!</span>
        <span>La menstruación es normal</span>
        <p>y mostrarla también debería serlo. Desde ahora, <b>el rojo no nos sonroja.</b></p>
      </>,
    img: img4
  },
  {
    txt:
      <>
        <p>Entre ciclos, hormonas, dolor y placer, a veces sentimos que nuestro cuerpo se sale de control. Vive sin
          miedo, sé libre,</p>
        <span>¡disfruta de ser mujer!</span>
      </>
    ,
    img: img5
  }
]
